<div fxFlex="100">

    <div class="index" fxLayout='row wrap'>
        <div fxFlex="100" fxLayout="column">
            <div fxFlex="100">
                <owl-carousel-o (change)="onImageChange($event)" [options]="LogoSlider" #owlCar class="product-slick">
                    <ng-container *ngFor="let image of imageList; index as j">
                        <ng-template carouselSlide [id]="j">

                            <div
                                *ngIf="!image.includes('medicineimages')&&!image.includes('http')&&!image.includes('commonimages')">
                                <img [ngStyle.gt-sm]="{height:productDetailHeight,width
                                  :'100%'}" [alt]="name" class="imgH collection-banner"
                                    [src]="bigImage+image | safe: 'resourceUrl'"
                                    onerror="this.src='assets/images/products/noImage/no-image.png';" alt="">
                            </div>

                            <ng-container *ngIf="image.includes('http')">
                                <ng-container>
                                    <img [ngStyle.gt-sm]="{height:productDetailHeight,width
                                      :'100%'}" [alt]="name" class="imgH collection-banner"
                                        [src]="image| safe: 'resourceUrl'"
                                        onerror="this.src='assets/images/products/noImage/no-image.png';" alt="">
                                </ng-container>
                            </ng-container>

                            <ng-container *ngIf="image.includes('commonimages')">
                                <img [ngStyle.gt-sm]="{height:productDetailHeight,width
                                  :'100%'}" [alt]="name" class="imgH collection-banner"
                                    [src]="serverPath7+image| safe: 'resourceUrl'"
                                    onerror="this.src='assets/images/products/noImage/no-image.png';" alt="">
                            </ng-container>
                        </ng-template>
                    </ng-container>
                </owl-carousel-o>

                <div style="margin-bottom: 5px;">

                </div>


                <div class="col-12 p-0" *ngIf="imageList.length > 1">
                    <div class="slider-nav">
                        <owl-carousel-o [options]="{items:3, dots:false, margin:10, autoWidth: true , autoHeight: true ,  autoplay: true,}"
                            class="product-slick">
                            <ng-container *ngFor="let image of imageList; index as i">
                                <ng-template carouselSlide [id]="i" [width]="100">
                                    <div *ngIf="!image.includes('medicineimages')&&!image.includes('http')&&!image.includes('commonimages')"
                                        class="owl-thumb" [class.active]="i == activeSlide">
                                        <img [style.height]="productDetailPageSubimageHeight" style="width: 100%;" [src]="bigImage+image | safe: 'resourceUrl'" [alt]="image.alt"
                                            class="img-fluid" (click)="owlCar.to(activeSlide = i.toString())">
                                    </div>
                                    <div *ngIf="image.includes('http')" class="owl-thumb"
                                        [class.active]="i == activeSlide">
                                        <img [style.height]="productDetailPageSubimageHeight" style="width: 100%;" [src]="image| safe: 'resourceUrl'" [alt]="image.alt" class="img-fluid"
                                            (click)="owlCar.to(activeSlide = i.toString())">
                                    </div>
                                    <div *ngIf="image.includes('commonimages')" class="owl-thumb"
                                        [class.active]="i == activeSlide">
                                        <img  [style.height]="productDetailPageSubimageHeight" style="width: 100%;" [src]="serverPath7+image| safe: 'resourceUrl'" [alt]="image.alt"
                                            class="img-fluid" (click)="owlCar.to(activeSlide = i.toString())">
                                    </div>
                                </ng-template>
                            </ng-container>
                        </owl-carousel-o>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>